export const theme = {
    color: {
        white: "#ffffff",
        black: "#000000cf",
        dustyGray: "#9b9a9a",
        silver: "#A3A3A3",
        cornFloweBlue: "#eeeeeeef",
        kleinBlue: "#0014a4ad",
        crimson: "#dc143c"
    },
    breakPoint: {


    }
};